/* eslint react/prop-types:0 */
import React from 'react';

import { LoadablePaint } from '@confluence/loadable';
import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';
import { MainLayout } from '@confluence/main-layout';
import { Screen } from '@confluence/screen';
import { useBooleanFeatureFlag, useSessionData } from '@confluence/session-data';

import SpaceBase from '../../SpaceBase';

const AdminCenterSpacePage = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-confluenceadmin-center" */ '@confluence/admin-center'
			)
		).AdminCenterSpacePage,
});

export const AdminCenterSpaceRoute = ({ name, params: { spaceKey } }) => {
	const { edition } = useSessionData();
	const isSpaceAliasFFEnabled = useBooleanFeatureFlag('confluence.frontend.space.alias');

	return (
		<Screen
			screenEvent={{
				name: 'adminCenterSpace',
				id: spaceKey,
				attributes: { edition },
			}}
			pageState={{
				routeName: name,
				spaceKey,
			}}
		>
			<MainLayout spaceKey={spaceKey} navView={CONTAINER_HOME_ID}>
				{isSpaceAliasFFEnabled ? (
					<SpaceBase>
						<AdminCenterSpacePage spaceKey={spaceKey} />
					</SpaceBase>
				) : (
					<AdminCenterSpacePage spaceKey={spaceKey} />
				)}
			</MainLayout>
		</Screen>
	);
};
